<template>
  <video
    ref="videoPlayer"
    class="video-js"
    data-setup='{"fluid": true}'
    style="width: 100%; height: 100%; border-radius: 8px"
    width="100%"
    height="100%"></video>
</template>

<script>
import videojs from 'video.js';
import 'video.js/dist/video-js.min.css';
import { merge } from 'lodash';

export default {
  name: 'VideoPlayer',
  props: {
    options: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      player: null,
    };
  },
  mounted() {
    this.player = videojs(
      this.$refs.videoPlayer,
      {
        autoplay: false,
        controls: true,
        ...this.options,
      },
      () => {
        this.player.log('onPlayerReady', this);
      }
    );
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>
